import { Navigate } from 'react-router';

import { useSessao } from '@/features/autenticacao/useSessao';

/**
 * Para onde a raiz leva.
 *
 * Existe porque os painéis são dois. Mandar todo mundo para `/acoes` levaria um perfil de
 * Produto para o Painel CS, que ele pode ver mas não é o dele: a fila é o que ele abre
 * para trabalhar.
 *
 * Quem tem os dois cai no CS, que é o começo do fluxo — alguém pede antes de alguém
 * analisar.
 *
 * Quem não tem nenhum dos dois também cai em `/acoes`, e não numa tela de erro: o servidor
 * responde 403 e a tela mostra a recusa. Inventar aqui um terceiro destino duplicaria a
 * decisão de acesso no cliente.
 */
export function DestinoInicial() {
  const { temPermissao } = useSessao();

  const destino = temPermissao('painel.cs')
    ? '/acoes'
    : temPermissao('painel.produto')
      ? '/fila'
      : '/acoes';

  return <Navigate to={destino} replace />;
}
